import { render, staticRenderFns } from "./PricingAcademiaComponent.vue?vue&type=template&id=d33ec1ac&"
import script from "./PricingAcademiaComponent.vue?vue&type=script&lang=ts&"
export * from "./PricingAcademiaComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PricingAcademiaComponent.vue?vue&type=style&index=0&id=d33ec1ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports